export var EApiDatafanPipelineStatus;
(function (EApiDatafanPipelineStatus) {
    EApiDatafanPipelineStatus[EApiDatafanPipelineStatus["DATA_COLLECTION"] = 0] = "DATA_COLLECTION";
    EApiDatafanPipelineStatus[EApiDatafanPipelineStatus["IS_COMPLETED"] = 1] = "IS_COMPLETED";
    EApiDatafanPipelineStatus[EApiDatafanPipelineStatus["DELETED"] = 2] = "DELETED";
    EApiDatafanPipelineStatus[EApiDatafanPipelineStatus["ARCHIVED"] = 3] = "ARCHIVED";
    EApiDatafanPipelineStatus[EApiDatafanPipelineStatus["CREDENTIAL_LOST"] = 4] = "CREDENTIAL_LOST";
})(EApiDatafanPipelineStatus || (EApiDatafanPipelineStatus = {}));
export var EApiDatafanPipelineMedia;
(function (EApiDatafanPipelineMedia) {
    EApiDatafanPipelineMedia["VK"] = "vk";
    EApiDatafanPipelineMedia["FB"] = "facebook";
    EApiDatafanPipelineMedia["GOOGLE"] = "google";
    EApiDatafanPipelineMedia["OK"] = "ok";
    EApiDatafanPipelineMedia["INSTAGRAM"] = "instagram";
    EApiDatafanPipelineMedia["MYTARGET"] = "mytarget";
    EApiDatafanPipelineMedia["YA"] = "yandex";
    EApiDatafanPipelineMedia["TIKTOK"] = "tiktok";
    EApiDatafanPipelineMedia["DATAFAN"] = "datafan";
    EApiDatafanPipelineMedia["TELEGRAM"] = "telegram";
    EApiDatafanPipelineMedia["SMMPLANNER"] = "smmplanner";
})(EApiDatafanPipelineMedia || (EApiDatafanPipelineMedia = {}));
export var EApiDatafanPipelineExportStatus;
(function (EApiDatafanPipelineExportStatus) {
    EApiDatafanPipelineExportStatus[EApiDatafanPipelineExportStatus["STARTED"] = 1] = "STARTED";
    EApiDatafanPipelineExportStatus[EApiDatafanPipelineExportStatus["SUCCESS"] = 2] = "SUCCESS";
    EApiDatafanPipelineExportStatus[EApiDatafanPipelineExportStatus["FAILURE"] = 3] = "FAILURE";
    EApiDatafanPipelineExportStatus[EApiDatafanPipelineExportStatus["REPEAT"] = 4] = "REPEAT";
})(EApiDatafanPipelineExportStatus || (EApiDatafanPipelineExportStatus = {}));
export var EApiDatafanPipelineExportType;
(function (EApiDatafanPipelineExportType) {
    EApiDatafanPipelineExportType[EApiDatafanPipelineExportType["EXCEL"] = 1] = "EXCEL";
    EApiDatafanPipelineExportType[EApiDatafanPipelineExportType["PDF"] = 3] = "PDF";
})(EApiDatafanPipelineExportType || (EApiDatafanPipelineExportType = {}));
//# sourceMappingURL=pipeline.js.map